<script setup>
import ResetPasswordForm from '@/components/forms/ResetPasswordForm.vue'
import * as THREE from 'three'
import NET from 'vanta/dist/vanta.net.min'
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const token = ref('')

onMounted(() => {
    NET({
        el: '#resetPasswordVanta',
        mouseControls: true,
        touchControls: true,
        gyroControls: false,
        scale: 1.0,
        scaleMobile: 1.0,
        color: 0x0f3384,
        backgroundColor: 0x01174d,
        THREE
    })

    token.value = route.params.token
})
</script>

<template>
    <div id="resetPasswordVanta">
        <div class="d-flex justify-center">
            <div class="authorization">
                <ResetPasswordForm :token="token" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
#resetPasswordVanta {
    min-width: 100%;
    min-height: 100%;
}
</style>
